import { useParams } from 'react-router-dom';

import { GlobalTypes, useStore } from '@modules';
import { IbanStatusesEnum } from '@modules/user/types';

export enum TranslationsEnum {
  profile = 'profile',
  transactions = 'transactions',
  invite_friend = 'invite_friend',
  accounts = 'accounts',
  wallets = 'wallets',
}

const { unknown, created } = IbanStatusesEnum;

export const useMenuLinks = () => {
  const params = useParams<{ currency: GlobalTypes.CryptoCurrencyEnum }>();
  const [{ global, user }] = useStore();

  const defaultCurrency = global.currencies.crypto[0];
  const currency = params.currency || defaultCurrency;
  const ibanStatus = user.data?.iban_status || unknown;

  const isShowAccountsMenu = ibanStatus === created;
  const inviteUrl = params.currency ? `${CONST.nav.invite}/${currency}` : CONST.nav.invite;

  return [
    { key: TranslationsEnum.wallets, url: CONST.nav.wallets },
    ...(isShowAccountsMenu ? [{ key: TranslationsEnum.accounts, url: CONST.nav.accounts }] : []),
    { key: TranslationsEnum.invite_friend, url: inviteUrl },
    { key: TranslationsEnum.profile, url: CONST.nav.profile },
  ];
};
export default useMenuLinks;
